import { type RefObject, useLayoutEffect } from 'react'

export function useCalendarScrollPosition(
  scrollContainerRef: RefObject<HTMLDivElement | null>,
  categoryColumnWidth: number
): void {
  useLayoutEffect(() => {
    const container = scrollContainerRef.current
    if (!container || typeof ResizeObserver === 'undefined') return

    const getVisibleTimelineWidth = (): number => Math.max(0, container.clientWidth - categoryColumnWidth)
    let visibleTimelineWidth = getVisibleTimelineWidth()
    let scrolledViewports = visibleTimelineWidth > 0 ? container.scrollLeft / visibleTimelineWidth : 0

    const handleScroll = (): void => {
      if (visibleTimelineWidth > 0 && getVisibleTimelineWidth() === visibleTimelineWidth) {
        scrolledViewports = container.scrollLeft / visibleTimelineWidth
      }
    }
    const observer = new ResizeObserver(() => {
      const nextVisibleTimelineWidth = getVisibleTimelineWidth()
      if (nextVisibleTimelineWidth === visibleTimelineWidth) return
      visibleTimelineWidth = nextVisibleTimelineWidth
      if (visibleTimelineWidth > 0) {
        container.scrollLeft = scrolledViewports * visibleTimelineWidth
      }
    })

    container.addEventListener('scroll', handleScroll, { passive: true })
    observer.observe(container)
    return () => {
      container.removeEventListener('scroll', handleScroll)
      observer.disconnect()
    }
  }, [scrollContainerRef, categoryColumnWidth])
}
